<script>
export default {
	methods: {
		getImage(image) {
			return `${require(`@/assets/images/components/LOADING/${image}`)}`;
		},
	},
};
</script>

<template>
	<div
		class="modal bounce absolute flex flex-col items-center justify-center w-full h-full p-3 z-40 right-0 bottom-0"
	>
		<img
			class="image -mb-5 w-28 relative z-10 object-contain"
			:src="getImage('votes_icon.png')"
			alt="Corazón en Mano"
		/>
		<div class="text gradient-gray  flex flex-col items-center justify-center  text-justify p6 rounded-3xl">
			<span class="text-lg mb-3">Cargando información...</span>
			<font-awesome-icon icon="fa-solid fa-spinner " class="fa-spin text-4xl elektra-red" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
/* we will explain what these classes do next! */
@keyframes bounce {
	0% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(1);
	}
}

.bounce {
	transition: transform 0.3s;
	animation: bounce 300ms;
}

.modal {
	background-color: rgba($color: #4a6c85, $alpha: 0.5);
}

.secondary-button {
	&:hover {
		animation: none;
	}
}

.image,.text{
	transform: translateY(-50%);
}

.text {
	width: 300px;
	height: 120px;
	// background: radial-gradient(
	// 		200% 200% at 100% 0%,
	// 		#DDDDDD,
	// 		#98989A 65%,
	// 		#F2F2F2
	// 	);
}
</style>
